import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  message: 'Save changes made to Outstanding Expenses?',
  title: 'Unsaved Changes',
})
